import { Empty } from '@upzi/web-shell/custom-components/empty';

export function JobDetailUnavailable({ onRetry }: { onRetry: () => void }) {
  return (
    <section
      role="alert"
      aria-label="Lỗi tải chi tiết việc làm"
      className="flex min-h-[520px] items-center justify-center px-6 py-10 text-center sm:px-20"
    >
      <Empty
        className="w-full"
        title="Đã xảy ra lỗi"
        content="Không thể tải dữ liệu lúc này. Bạn thử lại nhé."
        cta={{
          type: 'button',
          onClick: onRetry,
          label: 'Tải lại',
          variant: 'outline',
          className: 'rounded-xl font-semibold',
        }}
      />
    </section>
  );
}
